import { Box, Button, Card, CardHeader, Divider, Grid, List, ListItem, ListItemButton, ListItemText, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { get, post_form_data } from "../../../services/FetchHelper";
import EntityConstants from "../../../configs/EntityConstants";
import GoTable from "../../../common/GoTable/GoTable";
import { StudentSchema, StudentFormFields, StudentState } from "./Config.utils";
//Third party
import { Form, Formik } from "formik";
import toast from "react-hot-toast";
import GoForm from "../../../components/Inputs/GoForm";
import PermissionConstants from "../../../configs/PermissionConstants";
import usePermissions from "../../../hooks/usePermissions";
import Iconify from "../../../components/iconify/Iconify";
import SpinService from "../../../services/SpinService";

const tableHeaders = [
    { id: 'name', label: 'Name', align: 'left', type: "text" },
    { id: 'message', label: 'Message', align: 'left', type: "text" },
]

const notes = [
    "Download CSV by clicking download button",
    "Required column with * symbol",
    "Kindly make sure Class, Transport Type, Location, and Zone master is upto date",
    "Start Date and End Date must be following format YYYY-MM-DD"
]

const StudentUpload = () => {
    const spinService = SpinService();
    const permissions = usePermissions();
    const formData = new FormData();
    const [selectedFile, setSelectedFile] = useState(null);
    const [results, setResults] = useState([]);
    const [formFields, setFormFields] = useState(StudentFormFields);

    const handleFileUpload = (event) => {
        if (event.target.files.length > 0) {
            setSelectedFile(event.target.files[0])
        }
    };

    const handleSubmit = async (values) => {
        formData.append("school_id", values.school_id);
        formData.append("file", selectedFile);
        spinService.on();
        const response = await post_form_data(EntityConstants.CSV_STUDENT_UPLOAD, formData);
        const data = await response.json();
        spinService.off();
        setResults(data);
    };

    const attachOptions = (name, options) => {
        setFormFields(prevFormFields =>
            prevFormFields.map(field =>
                field.name === name && (field.type === "select" || field.type === "multiselect")
                    ? { ...field, options: options }
                    : field
            )
        );
    };

    const getSchoolsByCompanies = async () => {
        spinService.on();
        const response = await get(EntityConstants.SCHOOLSBYCOMPANIES);
        const data = await response.json();
        attachOptions("school_id", data);
        spinService.off();
    };

    useEffect(() => {
        getSchoolsByCompanies();
    }, []);

    return (
        <div>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <Typography variant="h6">Notes</Typography>
                    <Box>
                        <List>
                            {
                                notes.map((note, index) => {
                                    return <ListItem key={index} disablePadding>
                                        <ListItemButton>
                                            <ListItemText id={index} primary={note} />
                                        </ListItemButton>
                                    </ListItem>
                                })
                            }
                        </List>
                    </Box>
                </Grid>
                <Grid item xs={6}>

                    <Typography variant="h6">Form Fields</Typography>
                    <Box
                    // sx={{
                    //     display: 'flex',
                    //     justifyContent: 'center',
                    //     alignItems: 'center',
                    //     height: '50vh',
                    // }}
                    >
                        <Box sx={{ p: 2, textAlign: "center" }}>
                            <Formik
                                enableReinitialize
                                initialValues={StudentState}
                                validationSchema={StudentSchema}
                                onSubmit={(values) => handleSubmit(values)}
                            >
                                {({
                                    values,
                                    touched,
                                    errors,
                                    dirty,
                                    isSubmitting,
                                    handleChange,
                                    handleBlur,
                                    handleSubmit,
                                }) => (
                                    <Form noValidate onSubmit={handleSubmit}>

                                        <Grid
                                            container
                                            maxWidth="sm"
                                            rowSpacing={1}
                                            columnSpacing={{ xs: 1, sm: 2, md: 2 }}
                                        >
                                            {formFields.map((formField, index) => {
                                                return (
                                                    <Grid key={index} item xs={12} sm={12} md={6} lg={6}>
                                                        <GoForm
                                                            config={formField}
                                                            values={values}
                                                            touched={touched}
                                                            errors={errors}
                                                            handleChange={handleChange}
                                                        />
                                                    </Grid>
                                                );
                                            })}
                                        </Grid>
                                        {selectedFile && (
                                            <Typography variant="body1">Selected File: {selectedFile.name}</Typography>
                                        )}
                                        <input
                                            type="file"
                                            onChange={handleFileUpload}
                                            style={{ display: 'none' }}
                                            id="file-upload"
                                        />
                                        <label htmlFor="file-upload">
                                            <Button variant="contained" component="span" color="warning">
                                                Choose File
                                            </Button>
                                        </label>

                                        <Box sx={{ p: 2, textAlign: "right" }}>
                                            {/* {permissions.has(PermissionConstants.CSV_STUDENT_UPLOAD) && */}
                                            <Button
                                                disabled={selectedFile === null}
                                                variant="contained"
                                                startIcon={<Iconify icon="eva:save-fill" />}
                                                type="submit"
                                            >
                                                Submit
                                            </Button>
                                            {/* } */}
                                        </Box>
                                    </Form>
                                )}
                            </Formik>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
            <br />
            {results.length > 0 && <Typography variant="h6">Result</Typography>}

            {
                results.length > 0 && <Card>
                    <GoTable
                        tableHeads={tableHeaders}
                        tableDatas={results}
                        totalCount={0}
                        search={false}
                        pagination={false}
                    />
                </Card>
            }</div>
    )
};

export default StudentUpload;